import { basketItemsVar } from '../utils/reactiveVar'
import { HookMethodArgs } from '../utils/types'

export const removeItems =
  ({ updateBasketOutletId, navigateToBasket }: HookMethodArgs) =>
  ({
    basketItemIds,
    shouldNavigateToBasket = true,
  }: {
    basketItemIds: string[]
    shouldNavigateToBasket?: boolean
  }): void => {
    // navigate back to the basket
    if (shouldNavigateToBasket) navigateToBasket()
    // Using the reactiveVar directly due to race condition created with existingItems (previous state) when calling add and remove consecutively
    const updatedBasketItems = basketItemsVar().filter(
      basketItem => !basketItemIds.includes(basketItem.id)
    )

    basketItemsVar(updatedBasketItems)
    if (updatedBasketItems.length === 0) {
      updateBasketOutletId(null)
    }
  }
